import { GENDER_SAVE } from './gender.action-types';

const INITIAL_STATE = {
  selected: null,
};

const genderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GENDER_SAVE:
      return { ...state, selected: action.payload };
    default:
      return state;
  }
};

export default genderReducer;
